import type { RedoMerchantSegmentsRpcClient } from "@redotech/redo-merchant-segments-rpc/client";
import { createRedoMerchantSegmentsRpcClient } from "@redotech/redo-merchant-segments-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMerchantSegmentsRpcClientContext: Context<
  RedoMerchantSegmentsRpcClient | undefined
> = createContext<RedoMerchantSegmentsRpcClient | undefined>(undefined);
RedoMerchantSegmentsRpcClientContext.displayName =
  "RedoMerchantSegmentsRpcClientContext";

export function RedoMerchantSegmentsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantSegmentsRpcClient({
      baseURL: new URL(`${baseUrl}/segments-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMerchantSegmentsRpcClientContext.Provider value={client}>
      {children}
    </RedoMerchantSegmentsRpcClientContext.Provider>
  );
}
